// extracted by mini-css-extract-plugin
module.exports = {"placeholderHeight":"az_dR","categoryresultbottom":"az_eR","removeTopMargin":"az_fR"};